import { RootState } from "@app/lib/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  selectedSellProperty: {},
  listingType: [],
  selectedListing: [],
  media: [],
  upgradedService: [],
};

export const propertiesSlice = createSlice({
  name: "sellProperties",
  initialState,
  reducers: {
    setSellSelectedProperty: (state, action: PayloadAction<any>) => {
      state.selectedSellProperty = action.payload;
    },
    setSellListingType: (state, action: PayloadAction<any>) => {
      state.listingType = action.payload;
    },
    setSelectedListing: (state, action: PayloadAction<any>) => {
      state.selectedListing = action.payload;
    },
    setUploadedImages: (state, action: PayloadAction<any>) => {
      state.media = action.payload;
    },
    setNewUpgradedService: (state, action: PayloadAction<any>) => {
      state.upgradedService = action.payload;
    },
  },
});

export const {
  setSellSelectedProperty,
  setSellListingType,
  setSelectedListing,
  setUploadedImages,
  setNewUpgradedService,
} = propertiesSlice.actions;

export const getSelectedSellProperty = (state: RootState) =>
  state.sellProperties.selectedSellProperty;

export const getSellListingType = (state: RootState) =>
  state.sellProperties.listingType;

export const getSelectedListing = (state: RootState) =>
  state.sellProperties.selectedListing;

export const getUploadedImages = (state: RootState) =>
  state.sellProperties.media;

export const getUpgradedService = (state: RootState) =>
  state.sellProperties.upgradedService;

export default propertiesSlice.reducer;
